module.exports = __webpack_public_path__ + "static/media/arbutus-292_edited-min.7186b127.jpg";